<template>
    <header
        class="border-b-[1px] xl:hidden fixed bg-white shadow-sm w-full top-0"
    >
        <div class="px-5 py-3 flex items-center justify-between">
            <div class="flex items-center">
                <figure>
                    <Icon
                        name="Perfil"
                        class="!text-primary h-14 w-14 bg-white"
                    />
                </figure>
                <div class="px-[18px] flex flex-col">
                    <span class="text-[16px] font-bold text-primary"
                        >Apelido da pessoa</span
                    >
                    <!-- <span class="text-[12px] font-medium text-gray-600">Editar perfil</span> -->
                    <NavLink
                        @click="putWaitResponse()"
                        @click.middle="putWaitResponse()"
                        :class="{ 'pointer-events-none': waitResponse }"
                        class="text-[12px] font-medium text-gray-600"
                        href="my-profile"
                        :active="route().current('dashboard')"
                    >
                        Editar Perfil
                    </NavLink>
                </div>
            </div>
            <Icon
                @click="$emit('close')"
                name="SetaDireita"
                class="text-primary"
            />
        </div>
    </header>
    <nav
        class="px-5 xl:px-[14vw] pt-20 bg-primary xl:items-center pb-24 min-h-screen xl:flex xl:flex-col"
    >
        <button
            @click="$emit('close')"
            class="text-white self-end hidden xl:block xl:translate-y-8"
        >
            Voltar >
        </button>
        <div
            v-for="(navLink, key) in navLinks"
            :key="key"
            class="text-white border-b-[1px] border-[#e5a5a5] pb-5 pt-5 xl:min-w-[500px] text-center"
        >
            <NavLink
                @click="navLink.click? navLink.click(): putWaitResponse()"
                @click.middle="putWaitResponse()"
                :class="{ 'pointer-events-none': waitResponse }"
                class="w-full font-normal text-[1.5rem] leading-[1vh] cursor-pointer"
                :target="navLink.target"
                :href="navLink.route"
                :active="route().current('dashboard')"
            >
                {{ navLink.text }}
            </NavLink>
        </div>
        <!-- <div class="text-white border-b-[1px] border-[#e5a5a5] pb-5 pt-5 xl:min-w-[500px] text-center">
            <a class="w-full font-normal text-[1.5rem] leading-[1vh] cursor-pointer" :href="$page.props.auth.user.urlReconhece" target="_blank">
                Troque seus pontos
            </a>
        </div> -->
    </nav>
    <transition>
        <div
            v-if="showModalUnderMaintance"
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
        >
            <div
                class="bg-white border-[1px] border-gray-200 rounded-[4px] max-w-[348px] w-full px-4 py-4"
            >
                <button class="float-right" @click="showModalUnderMaintance = false">
                    <Icon name="Fechar" />
                </button>
                <h1 class="text-[20px] font-bold text-primary text-center">
                    Aviso
                </h1>
                <p class="mt-2.5">
                    Função em manutenção.
                </p>
            </div>
        </div>
    </transition>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import NavLink from "@/Components/NavLink.vue";

export default {
    components: {
        Icon,
        NavLink,
    },
    props: {
        urlReconhece: String,
        canUploadPhotoInRegion: Boolean,
    },
    data() {
        return {
            permissions: [
                "GERENTE",
                "LIDER",
                "LÍDER",
                "COORDENADOR",
                "PROMOTOR",
                "REPOSITOR",
            ],
            showModalUnderMaintance: false,
            navLinks: [],
            waitResponse: false,
        };
    },
    emits: ['close'],
    mounted() {
        switch (this.$page.props.auth.user.participant.type) {
            case "M": {
                let obj = [
                    { route: route("dashboard"), text: "Home" },
                    { route: route("news"), text: "Feed" },
                    // { route: route("winners"), text: "Ganhadores" },
                    { route: route("how-it-works"), text: "Como Ganhar" },
                    { route: route("extrato-de-pontos"), text: "Extrato" },
                    { route: route("gallery"), text: "Galeria de Fotos" },
                    {
                        route: route("campaigns"),
                        text: "Materiais de Campanha",
                    },
                ];

                this.navLinks = obj;

                if (this.permissions.includes(this.jobTitle)) {
                    let obj = {
                        route: route("performance"),
                        text: "Desempenho",
                    };
                    this.navLinks.splice(2, 0, obj);
                }

                if (this.isModerator) {
                    let obj = {
                        route: route("photo-voting"),
                        text: "Votação de Fotos",
                    };
                    this.navLinks.splice(this.navLinks.length - 1, 0, obj);
                }


                break;
            }

            case "V": {
                let obj = [
                    { route: route("gallery"), text: "Galeria de Fotos" },
                    { route: route("extrato-de-pontos"), text: "Extrato" },
                ];

                this.navLinks = obj;
                break;
            }
        }

    },
    computed: {
        participantId() {
            return this.$page.props.auth.user.participant.id;
        },
        jobTitle() {
            return this.$page.props.auth.user.participant.jobTitle;
        },
        contestJudges() {
            return this.$page.props.auth.user.contestJudges;
        },
        isModerator() {
            return Boolean(this.$page.props.auth.user.isModerator?.data?.[0]);
        },
        isModerator() {
            return this.contestJudges?.length > 0 || this.isModerator;
        },
    },
    methods: {
        putWaitResponse() {
            this.waitResponse = true;

            setTimeout(() => {
                this.waitResponse = false;
            }, 1000);
        },
        participantType() {
            return this.$page.props.auth.user.participant.type;
        },
        isDigi() {
            return this.$page.props.auth.user?.email?.includes('@digi.ag');
        },
        isAdmin() {
            return this.$page.props.auth.user?.participant?.role?.toLowerCase() == 'admin';
        },
        isMerchan() {
            return this.participantType === 'M';
        },
        isManager() {
            return this.jobTitle === 'GERENTE';
        },
        canUploadPhoto() {
            return this.isAdmin || this.isDigi || (this.isMerchan && !this.isManager);
        },
    },
};
</script>
